module.exports = __webpack_public_path__ + "static/MLB-a4c7e994432c3437b858b857172dee1e.png";